<template>
  <div class="dynamicItem">

    <el-row v-for="(item, index) in dynamics" @mouseenter="delShow" @mouseleave="delHide">

      <slot name="delSlot" :data="item.id" class="slot"></slot>

      <el-col :offset="3" :span="3" class="left">
        <span class="iconfont">&#xe64f;</span>
      </el-col>
      <el-col :offset="1" :span="14" class="right" @click.native="toDetails(item)">
        <p class="title">{{lang === 'zh' ? item.title : item.titleEn}}</p>
        <p class="content">{{lang === 'zh' ? item.word1 : item.word1En}}</p>
      </el-col>
    </el-row>

  </div>
</template>

<script>

  import { ref, reactive, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router';
  import { useStore, mapGetters } from 'vuex'
  import bus from 'vue3-eventbus'  //引入事件总线

  export default {
    name: "ResearchItem",
    props:{
      dynamics: {
        type: Array,
        default: [],
      }
    },
    computed: {
      ...mapGetters(['showLang'])
    },//computed
    emits:['delShow','delHide'],
    setup(props,context){

      onMounted(() => {

      })

      const route = useRoute()
      const router = useRouter()

      const store = useStore()
      let lang = ref('')
      lang.value = store.state.language;
      //监听事件总线
      bus.on('changeLang', type => lang.value = type);

      // 跳转到详细页
      function toDetails(detail) {
        //console.log('detail: ', encodeURIComponent(JSON.stringify(detail)))
        router.push('/dynamicDetails/' + encodeURIComponent(JSON.stringify(detail)))
        /*router.push({
          name: '/researchDetails',
          query: { research: detail }
        })*/
      }
      // 向父组件发射delShow
      function delShow() {
        context.emit('delShow');
      }
      // 向父组件发射delHide
      function delHide() {
        context.emit('delHide');
      }


      return{ lang,
        toDetails, delShow, delHide,
      }
    },
  }
</script>

<style scoped lang="less">

  .dynamicItem{

    .el-row:hover{
      .iconfont{
        transform: scale(1.2); // 放大1.2倍
        transition: all .3s; // 设置加载时间
      }
      /*transition: all 0.3s;
      box-shadow: 0 0 10px rgb(0 0 0  2%);*/
    }

    .el-row{

      position: relative;

      height: 164px;
      padding: 32px 0;
      //margin-bottom: 25px;
      margin-top: -20px;

      .left{
        border-right: 1px solid #eaeaea;
        color: #5ca131;
        padding-top: 10px;
        text-align: center;
        span{ font-size: 80px; }
        cursor: pointer;
      }

      .right{
        cursor: pointer;
        margin-top: 10px;
        .title{
          font-size: 18px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 6px;
          overflow: hidden;
        }
        .content{

          font-size: 14px;
          color: rgba(51,51,51,.75);

          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

    }

    .el-row:first-child{ margin-top: 0; }
  }

</style>